<ng-container *transloco="let t; prefix: 'workOrder'">
<div
  class="filter-container pb-3 d-flex align-items-center justify-content-between">
  <app-search
    [placeholder]="t('filters.searchPlaceholder')"
    [disabled]="isLoading"
    (searchTermUpdated)="onSearchTermUpdate($event)"
    [searchTerm]="searchTerm"
    [customWidth]="'380px'">
  </app-search>

  <div class="d-flex align-items-center gap-2">
    <app-make-model-filter
      [filter]="makeModelFilter"
      [accountFilterChanged$]="accountIdsChanged$"
      (filterChanged)="onMakeAndModelChange($event)">
    </app-make-model-filter>

    <app-workshop-filter
      [filter]="workshopFilter"
      [accountFilterChanged$]="accountIdsChanged$"
      (filterChanged)="onWorkshopFilterChange($event)">
    </app-workshop-filter>
  </div>
</div>

<div class="main-table work-order-requests-overview" [class.no-internal-scroll]="isLoading || hasError || workOrderRequests.length === 0">
  <table class="table" [class.state-table]="isLoading || hasError || workOrderRequests.length === 0">
    <thead>
      <tr>
        <th class="checkbox-col">

          @if (!isAllSelected && !isIndeterminate) {
            <button type="button" class="selection-toggle-btn" [disabled]="isLoading" (click)="toggleSelectAll()">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#DADADE" stroke-linejoin="round" />
              </svg>
            </button>
          }
          @if (isIndeterminate) {
            <button type="button" class="selection-toggle-btn" [disabled]="isLoading" (click)="toggleSelectAll()">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#EE2737" />
                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#EE2737" />
                <line x1="4.5" y1="8" x2="11.5" y2="8" stroke="white" stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>
          }
          @if (isAllSelected) {
            <button type="button" class="selection-toggle-btn" [disabled]="isLoading" (click)="toggleSelectAll()">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#EE2737" />
                <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#EE2737" />
                <path d="M2.95312 8.85384L6.28646 11.9788L12.9531 3.64551" stroke="white" stroke-width="2" stroke-linejoin="round" />
              </svg>
            </button>
          }

          <!-- <input
            type="checkbox"
            [checked]="selectAll"
            [indeterminate]="isIndeterminate"
            (change)="toggleSelectAll()" /> -->
        </th>
        <th class="work-order-id">
          {{ t('table.workOrderId') }}
          <button
            class="filter-button"
            [class.active]="sortColumn === 'workOrderId'"
            (click)="onSort('workOrderId')">
            <i class="ph ph-arrows-down-up"></i>
          </button>
        </th>
        <th class="asset">
          {{ t('table.asset') }}
          <button
            class="filter-button"
            [class.active]="sortColumn === 'asset'"
            (click)="onSort('asset')">
            <i class="ph ph-arrows-down-up"></i>
          </button>
        </th>
        <th class="scheduled-date">
          {{ t('table.dateCreated') }}
          <button
            class="filter-button"
            [class.active]="sortColumn === 'dateCreated'"
            (click)="onSort('dateCreated')">
            <i class="ph ph-arrows-down-up"></i>
          </button>
        </th>
        <th class="source">{{ t('table.source') }}</th>
        <th class="work-type">{{ t('table.serviceType') }}</th>
        <th class="work-type">{{ t('table.reason') }}</th>
        <th class="estimated-cost">
          {{ t('table.estCostAndTime') }}
          <button
            class="filter-button"
            [class.active]="sortColumn === 'estimatedCost'"
            (click)="onSort('estimatedCost')">
            <i class="ph ph-arrows-down-up"></i>
          </button>
        </th>
        <th class="priority">
          {{ t('table.priority') }}
          <button
            class="filter-button"
            [class.active]="sortColumn === 'priority'"
            (click)="onSort('priority')">
            <i class="ph ph-arrows-down-up"></i>
          </button>
        </th>
        <th class="actions">{{ t('table.actions') }}</th>
      </tr>
    </thead>

    @if (!isLoading && !hasError && workOrderRequests.length > 0) {
      <tbody>

        @for (request of workOrderRequests; track request.workOrderId) {
          <tr>
            <td class="checkbox-col">
              <input
                type="checkbox"
                [checked]="isSelected(request.workOrderId)"
                [disabled]="request.status === WorkOrderStatus.Rejected"
                (change)="toggleWorkOrderSelection(request.workOrderId)" />
            </td>
            <td class="work-order-id">
              <p>{{ request.workOrderNumber }}</p>
            </td>
            <td class="asset">
              <div
                class="asset-name-wrapper"
                [ngbTooltip]="request.assetName"
                placement="top"
                container="body">
                {{ request.assetName }}
              </div>
            </td>
            <td class="scheduled-date">
              <p>{{ formatDate(request.dateCreated) }}</p>
            </td>
            <td class="source">
              <div class="source-cell">
              <p class="source-label" [ngbTooltip]="WorkOrderSourceLabels[request.source] | transloco">{{ WorkOrderSourceLabels[request.source] | transloco }}</p>
              @if (request.faultImages && request.faultImages.length > 0) {
                <button
                  type="button"
                  class="photos-capsule"
                  [ngbTooltip]="getPhotoCountLabel(request)"
                  [attr.aria-label]="getPhotoCountLabel(request)"
                  (click)="onViewPhotos(request); $event.stopPropagation()">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 5H17.83L16.59 3.65C16.21 3.24 15.66 3 15.08 3H8.92C8.34 3 7.79 3.24 7.41 3.65L6.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM12 18C9.24 18 7 15.76 7 13C7 10.24 9.24 8 12 8C14.76 8 17 10.24 17 13C17 15.76 14.76 18 12 18Z" fill="currentColor"/>
                    <circle cx="12" cy="13" r="3" fill="currentColor"/>
                  </svg>
                  <span>{{ request.faultImages.length }}</span>
                </button>
              }
              </div>
            </td>

            <td class="work-type">
              <div class="work-type-cell">
                <p class="work-type-name">
                  {{ WorkOrderServiceTypeLabels[request.serviceType] | transloco }}
                </p>
                <p class="workshop-name">{{ request.workshopName }}</p>
              </div>
            </td>
            <td class="reason">
              <div
                class="asset-name-wrapper"
                [ngbTooltip]="request.localizedReason || request.reason || '-'"
                placement="top"
                container="body">
                {{ request.localizedReason || request.reason || '-' }}
              </div>
            </td>
            <td class="estimated-cost">
              <div class="cost-time-cell">
                @if (request.estimatedCost === 0 && !request.estimatedTime) {
                  <p class="cost">-</p>
                } @else {
                  <p class="cost">{{ request.estimatedCost ? formatCost(request.estimatedCost) : '-' }}</p>
                  @if (request.estimatedTime) {
                    <p class="time">{{ t('table.hoursValue', { hours: request.estimatedTime }) }}</p>
                  }
                }
              </div>
            </td>
            <td class="priority">
              <span
                class="priority-badge"
                [ngClass]="getPriorityClass(request.priority)">
                <span class="priority-indicator">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.63533 0C2.97667 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3287 0 6.63533 0ZM7.33333 10H6V8.66667H7.33333V10ZM7.33333 7.33333H6V3.33333H7.33333V7.33333Z" />
                  </svg>
                </span>
                {{ WorkOrderPriorityLabels[request.priority] | transloco }}
              </span>
            </td>
            <td class="actions">
              <div class="action-buttons">
                @if (request.status === WorkOrderStatus.Pending) {
                  <button
                    class="action-btn reject-btn"
                    (click)="onReject(request); $event.stopPropagation()"
                    [title]="t('rowActions.rejectRequest')">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M10.7946 4.23047L7.96598 7.05847L5.13798 4.23047L4.19531 5.17314L7.02331 8.00114L4.19531 10.8291L5.13798 11.7718L7.96598 8.9438L10.7946 11.7718L11.7373 10.8291L8.90931 8.00114L11.7373 5.17314L10.7946 4.23047Z"
                        fill="#4D4749" />
                    </svg>
                  </button>
                  <button
                    class="action-btn approve-btn"
                    (click)="onApprove(request); $event.stopPropagation()"
                    [title]="t('rowActions.approveRequest')">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.66534 10.3919L4.47001 8.19661L3.52734 9.13928L6.66534 12.2773L13.1367 5.80595L12.194 4.86328L6.66534 10.3919Z"
                        fill="#EE2737" />
                    </svg>
                    <span>{{ t('rowActions.approve') }}</span>
                  </button>
                }
                @if (request.status === WorkOrderStatus.Rejected) {
                  <button
                    class="action-btn status-action-btn status-rejected-btn"
                    (click)="
                      onRevertRejection(request); $event.stopPropagation()
                    "
                    [title]="t('rowActions.revertRejection')">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M1.75 10.5003V12.2503H3.5L9.70333 6.04699L7.95333 4.29699L1.75 10.5003ZM11.4717 4.27866C11.6583 4.09199 11.6583 3.79199 11.4717 3.60533L10.3947 2.52833C10.208 2.34166 9.908 2.34166 9.72133 2.52833L8.86417 3.38549L10.6142 5.13549L11.4717 4.27866Z"
                        fill="#4D4749" />
                    </svg>
                    <span>{{ t('rowActions.rejected') }}</span>
                  </button>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    }
  </table>
  @if (isLoading) {
    <div class="table-state-panel">
      <div class="spinner-container">
        <div class="spinner-border text-danger" role="status"></div>
      </div>
    </div>
  } @else if (hasError) {
    <div class="table-state-panel">
      <div class="error-container">
        <app-error-state></app-error-state>
      </div>
    </div>
  } @else if (workOrderRequests.length === 0) {
    <div class="table-state-panel">
      <div class="table__no-data">
        <app-empty-state></app-empty-state>
      </div>
    </div>
  }
</div>

<!-- Footer -->
<div class="bottom-options d-flex align-items-center justify-content-between">
  <p class="showing-text">{{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}</p>

  <app-pagination
    [totalPages]="totalPages"
    [currentPage]="page"
    (pageChange)="onPageChange($event)">
  </app-pagination>

  <div
    ngbDropdown
    #exportDropdown="ngbDropdown"
    class="export-listing"
    [autoClose]="true"
    [class.invisible]="true"
    placement="top-end">
    <div class="common-drop-down dropdown">
      <button
        class="btn btn-secondary dropdown-toggle d-flex align-items-center gap-2 export-btn"
        type="button"
        ngbDropdownToggle
        [disabled]="isLoading || isExporting">
        <span>{{ isExporting ? t('export.exporting') : t('export.export') }}</span>
        @if (!isExporting) {
          <img src="./assets/images-fuel/downloadIcon.svg" [attr.alt]="'common.export' | transloco" />
        }
      </button>

      <ul ngbDropdownMenu class="dropdown-menu export-menu">
        <li>
          <a
            ngbDropdownItem
            class="dropdown-item"
            style="cursor: pointer"
            (click)="exportDropdown.close(); onExport('excel')"
            >{{ t('export.excel') }}</a
          >
        </li>
        <li>
          <a
            ngbDropdownItem
            class="dropdown-item"
            style="cursor: pointer"
            (click)="exportDropdown.close(); onExport('csv')"
            >{{ t('export.csv') }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</div>
</ng-container>